import React from 'react'
import CountUp from 'react-countup';

function Hero2() {
  return (
        <div className='w-full h-auto flex  justify-center  p-4 overflow-x-hidden '>
            <div className='w-full flex flex-wrap  gap-6 lg:w-3/6 md:justify-end  md:flex-row  md:gap-3'>
                <div className='w-full sm:w-auto mx-6 mb-10 text-center'>
                <h2 className='text-sky-600 font-bold text-2xl'>
                    <CountUp start={0} end={2} duration={20} suffix='+'/>
                </h2>
                <h4 className='text-gray-800 font-semibold text-lg'>Years of experience</h4>
                </div> 
                <div className='w-full sm:w-auto mx-6 mb-10 text-center'>
                <h2 className='text-sky-600 font-bold text-2xl'>
                    <CountUp start={0} end={96} duration={20} suffix='%'/>
                </h2>
                <h4 className='text-gray-800 font-semibold text-lg'>Success rate</h4>
                </div> 
                <div className='w-full sm:w-auto mx-6 mb-10 text-center'>
                <h2 className='text-sky-600 font-bold text-2xl'>
                    <CountUp start={0} end={15} duration={20} suffix='+'/>
                </h2>
                <h4 className='text-gray-800 font-semibold text-lg'>Happy Client</h4>
                </div> 
                <div className='w-full sm:w-auto mx-6 mb-10 text-center'>
                <h2 className='text-sky-600 font-bold text-2xl'>
                    <CountUp start={0} end={45} duration={20} suffix='+'/>
                </h2>
                <h4 className='text-gray-800 font-semibold text-lg'>Project Completed</h4>
                </div> 
            </div> 
        </div>

    )
}

export default Hero2